// Timbo — first-run onboarding. Rendered as a sibling of <App/> (see index.js)
// as a FULL-SCREEN OPAQUE page (white bg, z-index above everything) so the app
// is never visible behind it. One page, five cards side by side. Shows once
// (localStorage `timbo_onboarded`); reopenable via window event
// 'timbo-open-onboarding' (Settings → Account → Replay tutorial).

import React, { useEffect, useState } from 'react';

const FONT = 'DM Sans, sans-serif';
const ORANGE = '#F97316';
const LOGO = process.env.PUBLIC_URL + '/timbo-logo.png';

const CARDS = [
  { title: 'Upload your videos', body: 'Drag & drop into the Studio — one or many. They line up in the Queue on the left.' },
  { title: 'Build each remix', body: 'Pick a Hook, a Script, a Title, a Voice and Music. Use the + buttons to add your own.' },
  { title: 'Manage your library', body: 'Open Feature Manager to create and edit your Hooks, Scripts and Concepts — shared with the team.' },
  { title: 'Export', body: 'Validate each video, then hit the green “Go to Export” bar to name and download your files.' },
  { title: 'Your ElevenLabs key', body: 'Add it in Settings → API Keys. Voiceovers run on your own credit.' },
];

export default function Onboarding() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let seen = true;
    try { seen = !!localStorage.getItem('timbo_onboarded'); } catch {}
    if (!seen) setOpen(true);
    const openIt = () => setOpen(true);
    window.addEventListener('timbo-open-onboarding', openIt);
    return () => window.removeEventListener('timbo-open-onboarding', openIt);
  }, []);

  const finish = () => {
    try { localStorage.setItem('timbo_onboarded', '1'); } catch {}
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 100000, background: '#fff',
      overflowY: 'auto', fontFamily: FONT, color: '#0a0a0a',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      padding: '48px 32px',
    }}>
      <img src={LOGO} alt="Timbo" style={{ height: 40, width: 'auto', marginBottom: 22 }} />
      <div style={{ fontSize: 26, fontWeight: 700, letterSpacing: '-0.02em', textAlign: 'center' }}>
        Welcome to Timbo
      </div>
      <div style={{ fontSize: 15, color: '#666', textAlign: 'center', maxWidth: 560, margin: '8px 0 34px' }}>
        Turn one influencer video into a whole batch of ad remixes. Here's how it works.
      </div>

      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: 16, width: '100%', maxWidth: 1040,
      }}>
        {CARDS.map((c, i) => (
          <div key={i} style={{
            border: '1px solid #eaeaea', borderRadius: 14, padding: '20px 18px',
            display: 'flex', flexDirection: 'column', gap: 10, background: '#fff',
          }}>
            <div style={{
              width: 30, height: 30, borderRadius: 9, background: 'rgba(249,115,22,0.12)',
              color: ORANGE, fontWeight: 700, fontSize: 14,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>{i + 1}</div>
            <div style={{ fontSize: 14.5, fontWeight: 700, marginTop: 2 }}>{c.title}</div>
            <div style={{ fontSize: 13, lineHeight: 1.5, color: '#666' }}>{c.body}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginTop: 40 }}>
        <button onClick={finish} style={{
          background: 'none', border: 'none', color: '#999', fontSize: 14, cursor: 'pointer', fontFamily: FONT,
        }}>Skip</button>
        <button onClick={finish} style={{
          height: 48, padding: '0 34px', border: 'none', borderRadius: 10,
          background: ORANGE, color: '#fff', fontWeight: 600, fontSize: 15, cursor: 'pointer', fontFamily: FONT,
        }}>Get started →</button>
      </div>
    </div>
  );
}
